import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-platforms',
  templateUrl: './platforms.component.html',
  styleUrls: ['./platforms.component.scss']
})
export class PlatformsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  data:any[] = [
    { name:"IOS_logo.png"
    },
    { name:"magento.png"
    },
    { name:"woocommerce.png"
    },
    { name:"easyintegration.png"
    },
    { name:"android.png"
    }
  ];
  slideConfig = {
    autoplay: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode:false,
    arrows:false,
    infinite:true,
    dots:false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode:true,
          dots:false,
          variableWidth:true,
          centerPadding: '60px'
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode:true,
          dots:false,
        }
      }
    ]
}
}
